import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteFamily() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`families/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
    },
  });

  const deleteFamily = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteFamily,
    error,
    isLoading,
    reset,
  };
}
